module.exports = __webpack_public_path__ + "static/media/bg_banner2.abb9f7de.png";